module.exports = __webpack_public_path__ + "img/icon.4792fb9c.png";